/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable eqeqeq */
/* eslint-disable import/no-cycle */
import React, { useState, useContext, useEffect } from 'react';
import { get, isEmpty } from 'lodash';
import { Box, Modal, Grid, Tooltip, Divider, Tab } from '@mui/material';
import { Rnd } from 'react-rnd';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { VeoliaButton, VeoliaIcon } from '@veolia.com/vds-react-components';
import { closeIconBlack } from '../../shared/assets/images';
import RoFeedAnalysis from './ro-feed-analysis';
// import ArgoAnalyzer from './argo-input/index';
import { defaultElementParameters, defaultModalOptions } from '../../shared/constantVariable';
import { convertUnitValues } from '../../shared/conversion-helper/unitConversion';
import { decimalFormatter } from '../../shared/helper';
import Notification from '../../shared/notification-modal';
import ButtonGrid from './button-grid';
import { RoContext, CLRoContext } from './argo-input/contextcall';
// import Clro from './clro'; // clro
import './ro.scss';

const NFInput = (props) => {
  let storageData = JSON.parse(localStorage.getItem('ro_ouput_data')) || {};
  const [systemData, setSystemData] = useState({});
  const unitData = JSON.parse(localStorage.getItem('unit_set_dict')) || {};
  const [unit_set_dict] = useState(unitData);
  const { visibleNF, handleCloseNF, dbTransactionDetails, roDetails,
    disabledStripperAndExplorerTab, setIsElementModelAccess, onElementClick, inputOutputFlag, setInputOutputFlag, translateObject, setokbuttonFormAutoSave, edges } = props;
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [elementParameters, setElementParameters] = useState(defaultElementParameters);
  const units = JSON.parse(localStorage.getItem('system-units'));
  const [value, setValue] = React.useState('1');
  const [strDescript, setStrDescript] = useState('');
  const handleSaveRocontextTableData = useContext(RoContext);
  const handleSaveCLRocontextTableData = useContext(CLRoContext);
  const [isShowErrorMessage, setIsShowErrorMessage] = useState(false);
  const [openRoForm, setOpenRoForm] = useState(false);

  const options = JSON.parse(localStorage.getItem('options'));
  const abFactor = get(options, 'abFactor', '0');
  const [roRadioABFactor, setRoRadioABFactor] = useState(abFactor || '0'); // for AB Value Factor
  // is options abvalue factor toggled
  const [isOptnAbValFctrToggled, setIsOptnAbValFctrToggled] = useState(false);

  const showErrorMessage = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      yesOrNo: false,
      type: 'error',
      title: 'Error',
      message: translateObject('Enter valid data in Pressure Vessels, Elements Per Vessel and Element Type'),
      onYes: () => handleCloseNF(),
      onNo: () => setModalOption(defaultModalOptions)
    });
  };
  // function to get element model on chnage
  const getnType = (curnType) => {
    const memDict = get(dbTransactionDetails, 'mem_dict', {});
    setStrDescript(memDict[curnType].strDescript);
  };

  // const updateTypeParameters = (params) => {
  //   setElementParameters(params);
  // };

  // function to update RO element parameters
  const updateElementParameters = (parameters) => {
    setElementParameters(parameters);
  };

  // function to close RO unitop form
  const handleClose_Ro = () => {
    if (isShowErrorMessage) {
      localStorage.setItem('globalExitBtn', 'true');
    }
    handleCloseNF();
  };

  // function to close RO input unitop form
  const handleCloseNFModal = () => {

    if (isShowErrorMessage) {
      setModalOption({
        ...defaultModalOptions,
        visible: true,
        message: translateObject('Do you want to close the RO input page?'),
        onYes: () => handleClose_Ro(),
        onNo: () => setModalOption(defaultModalOptions)
      });
    } else {
      setIsOptnAbValFctrToggled(false); // for abValue close issue
      handleCloseNF();
    };
  };

  // function to get the RO unitop name
  const getFeedName = () => {
    let roName = '';
    const local = localStorage.getItem(roDetails.id);
    if (local) {
      roName = ` - ${local}`;
    } else {
      roName = ` - RO ${Number(get(roDetails, 'id', '').split('_')[1]) + 1}`;
    }
    return roName;
  };

  const calculateFlowSheet = (str) => {
    handleSaveRocontextTableData.handleSaveRoTableData(handleSaveRocontextTableData.rowData, false);
    const appycheck = setInterval(() => {
      const apply = localStorage.getItem('roapply');
      if (apply == 0 || apply == 1) {
        clearInterval(appycheck);
        localStorage.removeItem('roapply');
      }
      if (apply == 1) {
        setInputOutputFlag(false);
        document.getElementById(`${str}_data`).click();
      }
    }, 100);
  };
  const handleChange = (event, newValue) => {

    // Check if the feed name includes 'CLRO'
    /** commentd by chandrashekhar because id is same RO_HP and CLRO form
     * so i have checked with type
     * if (getFeedName().includes('CLRO')) {
    */
    // if (getFeedName().includes('CLRO')) {
    // if (roDetails.type === 'customnode_CLROpump') {
    //   // Get the row data from the CLRocontext table
    //   const record = handleSaveCLRocontextTableData.rowData;
    //   // Filter out the records where pressureVessels is not 0
    //   const stagedData = record.filter((obj) => obj.pressureVessels !== 0);
    //   // Function to validate fields in the staged data
    //   const validateFields = (stagedData) => {
    //     // Check if any of the fields are empty or 0
    //     return stagedData.some((obj) => {
    //       const { application, elementGroup, elementModel, elementsperVessel } = obj;
    //       return (application === '' || elementGroup === '' || elementModel === '' || elementsperVessel === 0);
    //     });
    //   };
    //   // If staged data is empty or any fields are invalid, show error message and set value to 1
    //   if (isEmpty(stagedData) || validateFields(stagedData)) {
    //     showErrorMessage();
    //     setValue('1');
    //   } else {
    //     // If data is valid, save the data and set the new value
    //     handleSaveCLRocontextTableData.handleSaveCLRoTableData(record, false);
    //     setValue(newValue);
    //   }
    // } else {
    // If feed name does not include 'CLRO', get the row data from the Rocontext table
    const record = handleSaveRocontextTableData.rowData;
    // Filter out the records where pressureVessels is not 0
    const stagedData = record.filter((obj) => obj.pressureVessels !== 0);
    // Function to validate fields in the staged data
    const validateFields = (stagedData) => {
      // Check if any of the fields are empty or 0
      return stagedData.some((obj) => {
        const { application, elementGroup, elementModel, elementsperVessel } = obj;
        return (application === '' || elementGroup === '' || elementModel === '' || elementsperVessel === 0);
      });
    };
      // If staged data is empty or any fields are invalid, show error message and set value to 1
    if (isEmpty(stagedData) || validateFields(stagedData)) {
      showErrorMessage();
      setValue('1');
    } else {
      // If data is valid, save the data and set the new value
      handleSaveRocontextTableData.handleSaveRoTableData(record, false);
      setValue(newValue);
    }
    // }
  };
  // update feed pressure, product TDS and Average Flux.
  const getFloatVal = (val, fixedVal) => {
    if (val !== '' && !Number.isNaN(Number(val))) {
      return Number(val).toFixed(fixedVal);
    }
    return val || '-';
  };
  const systemdatavalues = (d) => {
    const obj = {};
    d.forEach((v) => {
      const name = localStorage.getItem(roDetails.id);
      if (name) {
        if (v.name !== 'System' && v.name === name) {
          // const obj = {};
          obj.name = v.name;
          obj.product_tds = getFloatVal(v.product_tds, 2);
          obj.feed_press = getFloatVal(v.feed_press, 2);
          obj.avg_flux = (v.avg_flux && unit_set_dict.Flux === 'm/s') ? Number.parseFloat(v.avg_flux).toExponential(2) : getFloatVal(v.avg_flux, 2);
          obj.max_flux = (v.max_flux && unit_set_dict.Flux === 'm/s') ? Number.parseFloat(v.max_flux).toExponential(2) : getFloatVal(v.max_flux, 2);
          // sys_info.push(obj);
        }
      }
    });
    setSystemData(obj);
  };
  const getData = () => {
    const newArry = Object.keys(storageData).map((key) => {
      if (storageData[key].unit_type && ['RO', 'RO_HP', 'RO_ERD', 'RO_PW', 'RO_TC', 'CLRO'].indexOf(storageData[key].unit_type) >= 0) {
        if (storageData[key].output_user && storageData[key].output_user.name) {
          return storageData[key].output_user;
        }
        return undefined;
      }
    });
    const storageArry = newArry.filter(m => m !== undefined);
    return storageArry;
  };
  const downLoadFlowSheetRo = (flowsheet_link) => {
    if (flowsheet_link) {
      window.open(`${flowsheet_link}`, '_blank', 'noreferrer');
    } else {
      setModalOption({ // show warning
        ...defaultModalOptions,
        visible: true,
        title: 'Warning',
        message: translateObject('Spec File is not available for this Element.'),
        yesOrNo: false,
        onNo: () => setModalOption(defaultModalOptions)
      });
    }
  };
  useEffect(() => {
    storageData = JSON.parse(localStorage.getItem('ro_ouput_data')) || {};
    const stagesList = getData(storageData);
    let flagStageList = true;
    for (let i = 0; i < stagesList.length; i += 1) {
      if (stagesList[i].system_data && stagesList[i].system_data.length) {
        flagStageList = false;
        systemdatavalues(stagesList[i].system_data);
        break;
      }
    }
    if (flagStageList) {
      setSystemData({});
    }
  }, [inputOutputFlag]);

  useEffect(() => {
    let current_ro_stage = localStorage.getItem('ro-dict');
    if (current_ro_stage) {
      current_ro_stage = JSON.parse(localStorage.getItem('ro-dict'));
      if (current_ro_stage && current_ro_stage.ro && current_ro_stage.ro[roDetails.id]) {
        const modelname = current_ro_stage.ro[roDetails.id]['grid-data'][0].elementModel;
        if (modelname) {
          const alldata = Object.values(dbTransactionDetails.elements_dict);
          const filterData = alldata.filter((ele) => {
            return modelname === ele.strModel;
          });
          if (filterData.length > 0) {
            setTimeout(() => {
              getnType(filterData[0].nType);
              setElementParameters(filterData[0]);
            }, 100);
          }
        }
      }
    }
  }, []);
  return (
    <Modal
      hideBackdrop
      open={visibleNF}
      onClose={handleCloseNFModal}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
      className="ro-modal"
    >
      <Box className=''>
        <Rnd
          default={
            {
              width: '85%',
              x: ((window.innerWidth / 2) - ((85 * (window.innerWidth / 100)) / 2)),
              // y: ((window.innerHeight / 2) - (((getFeedName().includes('CLRO') ? 70 : 70) * (window.innerHeight / 100)) / 2)),
              y: ((window.innerHeight / 2) - ((((roDetails.type === 'customnode_CLROpump') ? 70 : 70) * (window.innerHeight / 100)) / 2)),
            }
          }
          enableResizing={{
            bottom: false, bottomLeft: false, bottomRight: false,
            left: true, right: true,
            top: false, topLeft: false, topRight: false
          }}
          allowAnyClick={false}
          enableUserSelectHack={false}
          resizeHandleStyles={{ 'right': { 'width': '10px' } }} // reducing width of right handle to 5px ---> kranthi
          minWidth='47%'
          // maxHeight='100%'
          cancel=".no_drag, .ro-header-text,
           .content-tab-title, .ro-radio-label, .combined-input-field, .MuiButton-contained, .ro-table-grid"
          className='ro-box'>
          <Box>
            <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
            <RoContext.Provider value={handleSaveRocontextTableData}>
              <Grid container className="ro-grid-container">
                <Grid item xs={12} className="ro-header-grid">
                  {/* <div className="ro-header-text rufusBld no_drag S_heading" id='roFeedName'>{getFeedName().includes('CLRO') ? `CLRO - ${getFeedName().replace('-', '')}` : `RO Element Data ${getFeedName()}`}</div> */}
                  <div className="ro-header-text rufusBld no_drag S_heading" id='roFeedName'>{(roDetails.type === 'customnode_CLROpump') ? `DSSRO - ${getFeedName().replace('-', '')}` : `NF Element Data ${getFeedName()}`}</div>
                  <div className="ro-close-icon no_drag">
                    <Tooltip title="Close">
                      <img src={closeIconBlack} alt="close" onClick={handleCloseNFModal} style={{ width: '14px', padding: '11px' }}
                        className="pointer" />
                    </Tooltip>
                  </div>
                </Grid>
                {/* {!getFeedName().includes('CLRO') ? */}
                <Grid item xs={12} className="ro-body-grid" style={{ maxHeight: 420, overflow: 'auto' }}>
                  {/* <TabContext value={value} className='tab-context'>
                    <Box className='tab-box'
                      sx={{
                        // borderBottom: 1,
                        width: '100%',
                        borderColor: 'divider'
                      }}
                    > */}
                  {/* <TabList onChange={handleChange} className='tab-list'> */}
                  {/* {!getFeedName().includes('CLRO') ? <Tab className='M_Regular secoundary-text-color-Primary-default' label={translateObject('RO Parameters')} value="1" /> : */}
                  {/* {!(roDetails.type === 'customnode_CLROpump') ? <Tab className='M_Regular secoundary-text-color-Primary-default' label={translateObject('RO Parameters')} value="1" /> :
                          <Tab className='M_Regular secoundary-text-color-Primary-default' label={translateObject('DSSRO Parameters')} value="1" />}
                        <Tab className='M_Regular secoundary-text-color-Primary-default' label={translateObject('Argo Analyzer')} value="2" />
                      </TabList>
                    </Box> */}
                  {/* {!getFeedName().includes('CLRO') ? */}
                  <Grid item xs={12} className="ro-content-grid" style={{ paddingBottom: 16 }}>
                    <Grid container>
                      <Grid item xs={12}>
                        <RoFeedAnalysis
                          handleCloseNFModal={handleCloseNFModal}
                          dbTransactionDetails={dbTransactionDetails}
                          roDetails={roDetails}
                          elementParameters={elementParameters}
                          updateElementParameters={updateElementParameters}
                          handleCloseNF={handleCloseNF}
                          disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
                          setIsElementModelAccess={setIsElementModelAccess}
                          setIsShowErrorMessage={setIsShowErrorMessage}
                          isShowErrorMessage={isShowErrorMessage}
                          getnType={getnType}
                          setElementParameters={setElementParameters}
                          onElementClick={onElementClick}
                          isOptnAbValFctrToggled={isOptnAbValFctrToggled}
                          setIsOptnAbValFctrToggled={setIsOptnAbValFctrToggled}
                          roRadioABFactor={roRadioABFactor}
                          setRoRadioABFactor={setRoRadioABFactor}
                          translateObject={translateObject}
                          openRoForm={openRoForm}
                          setOpenRoForm={setOpenRoForm}
                          downLoadFlowSheetRo={downLoadFlowSheetRo}
                          getIdRoForm = {roDetails.id}
                          edges = {edges}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {systemData && systemData.name &&
                          <Grid item xs={12} className='output-wrapper no_drag' style={{ marginBottom: 5 }}>
                            <div className='output-ro-machine'>
                              <span className='S_Bold'>{translateObject('Output')}</span>
                            </div>
                            <div className='output-ro-machine'>
                              <span className=' mr10 output-feed'>{translateObject('Feed Pressure')}, {get(units, 'pressure', 'atm')}</span>
                              <span className='S_Regular secoundary-text-color-Primary-default'>{systemData.feed_press}</span>
                            </div>
                            <div className='output-ro-machine'>
                              <span className=' mr10 output-feed'>{translateObject('Product TDS')}, mg/L</span>
                              <span className='S_Regular secoundary-text-color-Primary-default'>{systemData.product_tds}</span>
                            </div>
                            <div className='output-ro-machine'>
                              <span className=' mr10 output-feed'>{translateObject('Average Flux')}, {get(units, 'flux', 'gfd')} </span>
                              <span className='S_Regular secoundary-text-color-Primary-default'>{systemData.avg_flux}</span>
                            </div>
                          </Grid>
                  }
                  <Grid item xs={12} className='output-wrapper no_drag'>
                    <div className='download-factsheet'>
                      <div className='output-ro-machine'>
                        <VeoliaButton
                          htmlType="button"
                          icon="picture_as_pdf"
                          iconPosition="left"
                          size="small"
                          variant="secondary"
                          disabled={!strDescript}
                          onClick={() => downLoadFlowSheetRo(elementParameters.flowsheet_link)}
                        >
                                Download Factsheet
                        </VeoliaButton>
                      </div>
                    </div>
                    <div className='output-ro-machine-wrapper'>
                      <div className='output-ro-machine'>
                        <span className='mr10 output-feed'>{translateObject('Type')}: </span>
                        <span className='S_Regular secoundary-text-color-Primary-default' style={{ display: 'inline-block', width: 115 }}> {strDescript}</span>
                      </div>
                      <div className='output-ro-machine'>
                        <span className='mr10 output-feed'>{translateObject('Area')}</span>
                        <span className='S_Regular secoundary-text-color-Primary-default'>
                          {(units && units.flux === 'gfd') ?
                            Math.round(decimalFormatter(get(elementParameters, 'Area', 0) * 10.76, 2)) :
                            decimalFormatter(get(elementParameters, 'Area', 0), 2)}
                          {(units && units.flux === 'gfd') ? <span>ft<sup>2</sup></span> : <span>m<sup>2</sup></span>}</span>
                      </div>
                      <div className='output-ro-machine'>
                        <span className='mr10 output-feed'>{translateObject('Rejection')}</span>
                        <span className='S_Regular secoundary-text-color-Primary-default'>
                          {decimalFormatter(get(elementParameters, 'Nano(2)', 0), 2)} {' '} %
                        </span>
                      </div>
                      <div className='output-ro-machine'>
                        <span className='mr10 output-feed'>{translateObject('Nominal Flow')}</span>
                        <span className='S_Regular secoundary-text-color-Primary-default'>
                          {convertUnitValues(get(elementParameters, 'Nano(3)', 0), get(units, 'flow', 'Bbl/hr'))}
                          {' '}
                          {get(units, 'flow', 'Bbl/hr')}
                        </span>
                      </div>
                      <div className='output-ro-machine'>
                        <span className='mr10 output-feed'>{translateObject('Test TDS')}, mg/L</span>
                        <span className='S_Regular secoundary-text-color-Primary-default'>
                          {decimalFormatter(get(elementParameters, 'Nano(1)', 0), 0)}
                          {' '}
                          {get(elementParameters, 'Nano(x)', '')}
                        </span>
                      </div>
                      <div className='output-ro-machine'>
                        <span className='mr10 output-feed'>{translateObject('Test Pressure')}</span>
                        <span className='S_Regular secoundary-text-color-Primary-default'>
                          {convertUnitValues(get(elementParameters, 'Nano(0)', 0), get(units, 'pressure', 'atm'))}
                          {' '}
                          {get(units, 'pressure', 'atm')}
                        </span>
                      </div>
                      <div className='output-ro-machine'>
                        <span className='mr10 output-feed'>{translateObject('Max Pressure')}</span>
                        <span className='S_Regular secoundary-text-color-Primary-default'>
                          {convertUnitValues(get(elementParameters, 'Nano(4)', 0), get(units, 'pressure', 'atm'))}
                          {' '}
                          {get(units, 'pressure', 'atm')}
                        </span>
                      </div>
                    </div>
                  </Grid>
                  {/* </TabContext> */}
                </Grid>
              </Grid>
              {/* {value === '1' && <> */}
              <Divider />
              <Grid item xs={12}>
                <ButtonGrid
                  calculateFlowSheet={calculateFlowSheet}
                  inputOutputFlag={inputOutputFlag}
                  handleCloseNF={handleCloseNF}
                  handleCloseNFModal={handleCloseNFModal}
                  dbTransactionDetails={dbTransactionDetails}
                  roDetails={roDetails}
                  elementParameters={elementParameters}
                  updateElementParameters={updateElementParameters}
                  disabledStripperAndExplorerTab={disabledStripperAndExplorerTab}
                  setIsElementModelAccess={setIsElementModelAccess}
                  setIsShowErrorMessage={setIsShowErrorMessage}
                  getnType={getnType}
                  setElementParameters={setElementParameters}
                  onElementClick={onElementClick}
                  roRadioABFactor={roRadioABFactor}
                  setRoRadioABFactor={setRoRadioABFactor}
                  getFeedName={getFeedName}
                  translateObject={translateObject}
                  setokbuttonFormAutoSave={setokbuttonFormAutoSave}

                />
              </Grid>
              {/* </>} */}

            </RoContext.Provider>
          </Box>
        </Rnd>
      </Box>
    </Modal>
  );
};
export default NFInput;